export default __webpack_public_path__ + "static/media/events-page-gif.09c56d91.gif";